import { useQueries, useQuery } from '@tanstack/react-query';

import { fetchDraftVenues } from 'apis/merchant-onboarding-service/api';

import { DraftVenue } from '../../../apis/merchant-onboarding-service/types';

const useDraftVenues = (merchantId: string) => {
  const { data, error, refetch, isLoading } = useQuery(['merchant-onboarding-service/draft-venues', merchantId], () =>
    fetchDraftVenues(merchantId),
  );

  return { data, error, refetch, isLoading };
};

export const useDraftVenuesGroupedByMerchantId = (
  merchantIds: string[],
  statuses?: ('BLANK' | 'READY_TO_SUBMIT' | 'SUBMITTED_FOR_REVIEW' | 'VENUE_CREATED')[],
): {
  data: { merchantId: string; merchantName: string; draftVenues: DraftVenue[] }[];
  isSuccess: boolean;
} => {
  return useQueries({
    queries: merchantIds.map(merchantId => {
      return {
        queryKey: ['merchant-onboarding-service/draft-venues', merchantId],
        queryFn: () => fetchDraftVenues(merchantId),
      };
    }),
  }).reduce(
    (prev, cur, index, array) => {
      const draftVenues = (cur.data as DraftVenue[]) || [];
      const filteredDraftVenues = statuses ? draftVenues.filter(x => statuses.includes(x.status)) : draftVenues;

      const { merchantId, merchantName } = filteredDraftVenues.find(x => x) || {
        merchantId: undefined,
        merchantName: undefined,
        draftVenues: [],
      };

      if (merchantId && merchantName && draftVenues.length !== 0) {
        prev.data = [...prev.data, { merchantId, merchantName, draftVenues: filteredDraftVenues }];
      }

      return { ...prev, isSuccess: index + 1 === array.length && prev.data.length === merchantIds.length };
    },
    {
      data: [] as { merchantId: string; merchantName: string; draftVenues: DraftVenue[] }[],
      isSuccess: false,
    },
  );
};

export default useDraftVenues;
